import { useMenuBase, useMenuReportDialogs } from '@/composables';

export const openCampaignLinksDialog = (id?: string) => {
  const { dialogActionsEvents } = useMenuReportDialogs(useMenuBase());
  dialogActionsEvents.value.campaigns.campaignLinks(id);
};
